import React from 'react';

import { Bookings } from '@components/utilities/Bookings/Bookings';

export const CurrentBookings: React.FC = () => {
  return <Bookings type="current" />;
};
